import React, { useState } from 'react';
// import styles from './style.scss';
import './style.scss';
import { Input } from 'antd';
import { putUserChangeApi } from '../../../api';
import { messageSuccess } from '../../../components/message';
import accountEdit from '../../../assets/svg/account-edit.svg';
import getFormatMessage from '../../../locales/get-format-message';
import { isSupportUser } from '../../lib';
import { isSupportSystem } from '../../../config';

interface IProps {
  readonly username: string;
  readonly onReload: () => void;
}

export const AccountUsername = (props: IProps) => {
  const [editNameValue, setEditNameValue] = useState<string>('');
  const [edit, setEdit] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const updateUserName = async () => {
    setLoading(true);
    const res = await putUserChangeApi(editNameValue);
    if (res) {
      messageSuccess(getFormatMessage('edit_name_success'));
      props.onReload();
    }
    setLoading(false);
  };

  const onEdit = () => {
    setEditNameValue(props.username);
    setEdit(true);
  };

  const onChangeValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditNameValue(e.target.value.trim());
  };

  const onBlurValue = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value.trim();
    if (!val) return;
    if (val === props.username) {
      setEdit(false);
      return;
    }
    await updateUserName();
    setEdit(false);
  };

  const renderViewRow = () => {
    return (
      <>
        <span className="valueBox">{props.username}</span>
        {!isSupportUser() && !isSupportSystem() && (
          <img
            style={{ width: '12px', height: '12px' }}
            src={accountEdit}
            className="nameEditBtn"
            onClick={onEdit}
          />
        )}

        {/* <div className={styles.editBtn} onClick={onEdit}>
          Edit
        </div> */}
      </>
    );
  };

  const renderEditRow = () => {
    return (
      <div className="tagName">
        <Input
          autoFocus
          value={editNameValue}
          onChange={onChangeValue}
          onBlur={onBlurValue}
          className="c-antd-input-l-main"
          spellCheck="false"
          disabled={loading}
          style={{ borderRadius: '6px' }}
        />
      </div>
    );
  };

  return (
    <div className="nameBox">{edit ? renderEditRow() : renderViewRow()}</div>
  );
};
